import { Button, Input, message, Space } from "antd";
import React, { useState } from "react";
import { apiCall, apiDownload } from "../utils/Api";

export default function TodaysPasscode() {

    const [pass, setPass] = useState("");
    const downloadSupport = (_pass = pass) => {
        apiDownload({ passcode: _pass }, "remote_support/download");
    }

    return (
        <>
            <div style={{ "width": "400px", "margin": "0 auto", "padding": "20px 0px" }}>
                <Space >
                    <Input style={{"width" : "300px"}} maxLength={4} value={pass} onChange={(e) => setPass(e.target.value)} onKeyDown={(e) => {
                        if (e?.key === "Enter") {
                            downloadSupport(e.target.value);
                        }
                    }} className="extra-large-input" placeholder="Today's Password" size="large" />
                    <div onClick={() => downloadSupport()} className={"fab-toggle"}>Go!</div>
                </Space>
            </div>
        </>
    )
}